<template>
  <div class="p-4 flex justify-between items-center gap-1">
    <!-- START -->
    <div class="flex flex-col items-start justify-center gap-1">
      <span class="text-sm font-semibold text-surface-800"
        >App Update Available</span
      >
      <span class="text-2xs font-normal text-surface-600"
        >A new version of Traverse Studio is available. Please refresh the page
        to update.</span
      >
      <span class="text-2xs font-medium text-surface-800">{{
        `Auto-refreshing in ${remainingSeconds} ${remainingSeconds === 1 ? 'second' : 'seconds'}`
      }}</span>
    </div>

    <!-- END -->
    <div class="shrink-0">
      <AppButtonIcon
        v-tooltip="'Refresh'"
        icon="fa-regular fa-rotate-right"
        size="lg"
        @click="handleRefresh"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
function handleRefresh() {
  window.location.reload()
}

const { remainingMs } = useCountdownTimer(60 * 1000, undefined, handleRefresh)

const remainingSeconds = computed(() => {
  return Math.ceil(remainingMs.value / 1000)
})
</script>
